const defaultInitialZIndex = 2000;
let zIndex = 0;

// const setInitialZIndex = (zIndexOverrides) => {
//     if (typeof zIndexOverrides === 'number') {
//         defaultInitialZIndex = zIndexOverrides;
//     }
// };

/**
 * 使用层级
 * @return {number}  下一层级
 */
export function useZIndex() {
    zIndex++;
    return defaultInitialZIndex + zIndex;
}
